import { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from "prosemirror-model";
import {
	DefaultFontMarksNodeAttributesPart,
	generateDefaultFontMarkStyles,
	NodeSpecWithDefaultFontMarksSupport,
	parseDefaultFontMarks
} from "./attributes/defaultFontMarks";
import {
	generateIndentionStyles,
	IndentionNodeAttributesPart,
	NodeSpecWithIndentionSupport,
	parseIndention
} from "./attributes/indention";
import {
	TextAlignNodeAttributesPart,
	parseTextAlign,
	generateTextAlignStyles,
	NodeSpecWithTextAlignSupport
} from "./attributes/textAlign";
import { combineStyles } from "./attributes/utils";

export type ParagraphNodeAttributes =
	& TextAlignNodeAttributesPart
	& IndentionNodeAttributesPart
	& DefaultFontMarksNodeAttributesPart;

export type ParagraphNodeSpec =
	& NodeSpec
	& NodeSpecWithTextAlignSupport
	& NodeSpecWithIndentionSupport
	& NodeSpecWithDefaultFontMarksSupport;

export const paragraph: ParagraphNodeSpec = {
	attrs: {
		textAlign: { default: undefined },
		indention: { default: undefined },
		defaultFontMarks: { default: undefined }
	},
	content: "inline*",
	group: "block",
	parseDOM: [
		{
			tag: "p",
			getAttrs(node: Node | string): ParagraphNodeAttributes | false {
				if (!(node instanceof HTMLElement)) {
					throw new Error("Expected HTMLElement at this point");
				}

				const textAlignAttributes: TextAlignNodeAttributesPart = parseTextAlign(node);
				const indentionAttributes: IndentionNodeAttributesPart = parseIndention(node);
				const defaultFontMarkAttributes: DefaultFontMarksNodeAttributesPart = parseDefaultFontMarks(node);

				return {
					...textAlignAttributes,
					...indentionAttributes,
					...defaultFontMarkAttributes
				};
			}
		}
	],
	toDOM: (node: ProsemirrorNode): DOMOutputSpec => {
		const attrs = node.attrs as ParagraphNodeAttributes;

		const styleValue: string | undefined = combineStyles(
			generateTextAlignStyles(attrs),
			generateIndentionStyles(attrs),
			generateDefaultFontMarkStyles(attrs)
		);

		return [
			"p",
			{
				style: styleValue
			},
			0
		];
	},
	doesSupportTextAlign: true,
	doesSupportIndention: true,
	doesSupportDefaultFontMarks: true
};